import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@kognitos/lattice';
import type { EnumInputProps } from '../types';

/**
 * Enum input component rendered as a select dropdown
 *
 * Displays a dropdown for selecting from a predefined set of enum values.
 *
 * @param props - Component props
 * @returns JSX element containing the select dropdown
 */
export function EnumInput({
  name,
  value,
  options,
  onChange,
  error,
  required,
  placeholder,
  disabled,
}: EnumInputProps) {
  const { t } = useTranslation('automation-inputs');

  return (
    <Select
      value={value}
      onValueChange={onChange}
      required={required}
      disabled={disabled}
      data-testid={`input-${name}`}
    >
      <SelectTrigger
        id={name}
        aria-invalid={!!error}
        className={`bg-background ${error ? 'border-destructive focus:ring-destructive' : ''}`}
      >
        <SelectValue
          placeholder={placeholder || t('placeholders.select', { field: name })}
        />
      </SelectTrigger>
      <SelectContent>
        {options.map(option => (
          <SelectItem key={option.name} value={option.name || ''}>
            {option.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
